import HttpService from "@/common/ApiService";
import configuration from "@/../public/urlConfig.json";
import { Hotel } from "../url";
import vue from "vue";

const http = new HttpService(vue.prototype.$config.tourBaseAddress, {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
});
require("linqjs");
const factory = () => ({
    selectedPackage: {},
    bookingDetails:{},
    hotelId:0
});
export default {
    namespaced: true,
    state: factory(),
    mutations: {
        SetSelectedPackage(state, item) {
            state.selectedPackage = item;
        },
        SetHotelId(state, item) {
            state.hotelId = item;
        },
        SetBookingDetails(state, item) {
            state.bookingDetails = item;
        },
        EmptyBookingDetails(state) {
            state.bookingDetails = {};
        },
        ResetState(state) {
            Object.assign(state, factory());
        }
    },
    getters: {

        GetBookingDetails(state) {
            return state.bookingDetails;
        },
        GetSelectedPackage(state) {
            return state.selectedPackage;
        },
        GetHotelId(state) {
            return state.hotelId;
        },
    },
    actions: {

        async Reserve(context, params) {
            const response = await http.Post(Hotel.RESERVE_URL, params);

            return response.data.data;
        },
        async CreditBook(context, params) {
            const response = await http.Post(Hotel.CREDITBOOK_URL, params);

            return response.data.data;
        },

        async GetCredit(context, params) {
            const response = await http.Post(Hotel.GETCREDIT_URL, params);
            return response.data;
        },
        async GetTicket(context, params) {
            const response = await http.Post(Hotel.TICKET_URL, params);

            return response.data.data;
        },
        async GetVoucher(context, params) {
          
            const response = await http.Post(Hotel.VOUCHER_URL, params);

            return response.data.data;
        },
        async CreateVoucher(context, params) {
            
            const response = await http.Post(Hotel.CREATEVOUCHER_URL, params);

            return response.data.data;
        },
        SelectedPackage(context, item) {
            context.commit("SetSelectedPackage", item);
        },
        SetHotelId(context , item) {
            context.commit("SetHotelId", item);
            
        },
        BookingDetails(context, item) {
            context.commit("SetBookingDetails", item);
        },
        ResetState(context) {
            context.commit("ResetState");
        },
        
        BookingDetailsEmpty(context) {
            context.commit("EmptyBookingDetails");
        },
    }
}